import { resolveComponent as _resolveComponent, vShow as _vShow, createVNode as _createVNode, withDirectives as _withDirectives, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_alert = _resolveComponent("v-alert")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_card_actions = _resolveComponent("v-card-actions")!
  const _component_v_form = _resolveComponent("v-form")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_dialog = _resolveComponent("v-dialog")!

  return (_openBlock(), _createBlock(_component_v_dialog, {
    modelValue: _ctx.dialog,
    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.dialog) = $event)),
    persistent: "",
    width: "auto"
  }, {
    default: _withCtx(() => [
      _createVNode(_component_v_card, {
        loading: _ctx.loading,
        class: "pa-4 text-center",
        title: "Doação para o carta moz",
        "prepend-icon": "mdi-hand-heart"
      }, {
        default: _withCtx(() => [
          _withDirectives(_createVNode(_component_v_alert, {
            type: _ctx.sucesseMensage ? 'success' : 'error',
            title: _ctx.sucesseMensage ? 'sucesso' : '!!OPSHII.. ocorreu um Ero',
            text: _ctx.sucesseMensage ? 'Muito obrigado por ativamente suportar o nosso projete. n/    Desejamos a continuação de um optimo dia e bons estudos'
        : 'Um erro ocoreu ao tentar doar para o carta moz. Volte a tentar em 5min '
          }, null, 8, ["type", "title", "text"]), [
            [_vShow, _ctx.showMensage]
          ]),
          _createVNode(_component_v_card_text, null, {
            default: _withCtx(() => [
              _createTextVNode(" Ajude com um valor simbolico o nosso projeto ")
            ]),
            _: 1
          }),
          _createVNode(_component_v_form, {
            modelValue: _ctx.form,
            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.form) = $event))
          }, {
            default: _withCtx(() => [
              _createVNode(_component_v_text_field, {
                modelValue: _ctx.amount,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.amount) = $event)),
                variant: "outlined",
                label: "Valor",
                rules: _ctx.rules2,
                type: "number",
                suffix: "Mtn"
              }, null, 8, ["modelValue", "rules"]),
              _createVNode(_component_v_text_field, {
                modelValue: _ctx.phonenumber,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.phonenumber) = $event)),
                variant: "outlined",
                label: "Numero do m-pesa",
                rules: _ctx.rules,
                type: "number",
                prefix: "+258"
              }, null, 8, ["modelValue", "rules"]),
              _createVNode(_component_v_text_field, {
                modelValue: _ctx.nome,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.nome) = $event)),
                label: "Nome doador/a",
                hint: "Opcional(pode deixar em branco esse campo)"
              }, null, 8, ["modelValue"]),
              _createVNode(_component_v_card_actions, null, {
                default: _withCtx(() => [
                  _createVNode(_component_v_btn, {
                    loading: _ctx.loading,
                    onClick: _ctx.donete,
                    color: "error",
                    variant: "elevated",
                    disabled: !_ctx.form,
                    block: ""
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode("M-pesa")
                    ]),
                    _: 1
                  }, 8, ["loading", "onClick", "disabled"])
                ]),
                _: 1
              }),
              _createVNode(_component_v_btn, {
                onClick: _ctx.closedialog,
                icon: "mdi-alpha-x"
              }, null, 8, ["onClick"])
            ]),
            _: 1
          }, 8, ["modelValue"])
        ]),
        _: 1
      }, 8, ["loading"])
    ]),
    _: 1
  }, 8, ["modelValue"]))
}